import { Calendar } from 'lucide-react';

// DESIGN-SYSTEM.md §8 (Iconography): ícones de linha (Lucide, stroke 2) e
// 14–16px quando inline com texto — o `DatePicker`/`DateTimePicker` do MUI X
// renderiza por padrão o `CalendarIcon` Material preenchido de 24px num
// `IconButton` "medium" (40px), bem acima do padrão e maior que a própria
// caixa de 40px dos filtros (`tb-field`). Como nenhuma tela passa `slots` para
// os pickers, o ajuste vive aqui e é aplicado por `theme.js`
// (`components.Mui*Picker.defaultProps`) — `slotProps` locais (ex.: `textField`)
// continuam funcionando, o MUI mescla por slot.
export function PickerCalendarIcon() {
    return <Calendar size={16} strokeWidth={2} />;
}

// Botão `small` (26px = ícone 16 + padding 5), na linha do `icon-btn` 28px do §5.3.
export const pickerDefaultProps = {
    slots: { openPickerIcon: PickerCalendarIcon },
    slotProps: { openPickerButton: { size: 'small' } },
};
